import {
  replaceBlocksAndUpdateBasket,
  makeInput,
  start,
  end,
  showMessage,
  logMessage,
  getResponseByMode
} from './utils';
import {
  handlers
} from './handlers';

const ZERO = '0';
const MIN_VALUE = '1';
const MAX_VALUE = '10';
let formCart = document.querySelector('form[name=updateCart]');

addControlsHandler();

export function addControlsHandler() {
  let controls = document.querySelectorAll('.count__select, .count__input');
  controls.forEach((control) => {
    control.addEventListener('change', controlChangeHandler);
  });
}

function controlChangeHandler(evt) {
  let currentControl = evt.target;
  let currentValue = evt.target.value;
  let currentName = evt.target.name;
  let currentId = evt.target.id;
  let currentUrl = formCart.action;
  formCart = document.querySelector('form[name=updateCart]');

  if (currentValue === ZERO || currentValue === '') {
    evt.target.value = MIN_VALUE;
    currentValue = evt.target.value;
  }
  if (currentValue === MAX_VALUE && currentControl.tagName === 'SELECT') {
    currentControl.removeEventListener('change', controlChangeHandler);
    currentControl = replaceAmountControls(currentControl, currentValue, currentName, currentId);
    addControlsHandler();
  }

  start();

  const mock = {
    url: 'mocks/cart.html',
    options: {
      method: 'GET',
    }
  };

  const formAction = new URL(currentUrl);
  formAction.searchParams.set('ajax', 1);

  const real = {
    url: formAction.href,
    options: {
      method: 'POST',
      body: new FormData(formCart)
    }
  };

  const {
    url,
    options
  } = getResponseByMode(mock, real);

  fetch(url, options)
    // comment for mock START
    .then((response) => {
      if (response.ok) {
        return;
      }
      throw new Error(`Не удалось изменить количество товара`);
    })
    .then(() => {
      return fetch(window.location.href + '?tmpl=component&ajax=1');
    })
    // comment for mock END
    .then((response) => {
      if (response.ok) {
        return response.text();
      }
      throw new Error(`Не удалось изменить количество товара`);
    })
    .then((str) => {
      const parser = new DOMParser();
      const data = parser.parseFromString(str, 'text/html');
      replacePageBlocks(data);
      handlers();
    })
    .catch((error) => {
      console.warn(error);
      logMessage(error);
      showMessage(error.message);
    })
    .finally(() => {
      end();
    });
}

function replacePageBlocks(data) {
  let blocks = ['.cart__shopping', '.cart__gifts', '.aside-cart__prices'];
  replaceBlocksAndUpdateBasket(blocks, data);
}

function replaceAmountControls(select, value, name, id) {
  let input = createAmountControl(value, name, id);
  select.replaceWith(input);
  return input;
}

function createAmountControl(value, name, id) {
  return makeInput('number', 'count__input', value, MIN_VALUE, name, id);
}
